import { Card } from 'antd'
import React from 'react'
import CreateOrganizationLmsConfigForm from './CreateOrganizationLmsConfigForm'

const LmsSettingsCard = () => {
    return (
        <Card title='LMS Settings' bordered={false}>
            <CreateOrganizationLmsConfigForm />
        </Card>
    )
}

export default LmsSettingsCard
